var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('div',{staticClass:"page d-flex justify-content-center"},[_c('Icon',{staticClass:"initial-spinner fa-spin fa-4x text-primary",attrs:{"icon":"spinner"}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }